import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/financeiro/exportar/loading";
import { FinanceiroPrintClient } from "@/client/modules/financeiro/exportar/print-client";

/** Relatório mensal pro contador (cada carga fica na auditoria). */
export const Route = createFileRoute("/app/financeiro/exportar")({
  validateSearch: (s: Record<string, unknown>): { year?: string; month?: string } => ({
    year: s.year as string | undefined,
    month: s.month as string | undefined,
  }),
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => ensurePage(context.queryClient, apiQuery("financeiro", "exportPage", deps)),
  head: () => pageHead("Exportar financeiro"),
  pendingComponent: Loading,
  staleTime: Number.POSITIVE_INFINITY,
  component: ExportarPage,
});

function ExportarPage() {
  const search = Route.useSearch();
  const { data } = useApiSuspenseQuery("financeiro", "exportPage", search);
  return <FinanceiroPrintClient {...data} />;
}
